import React, { memo, useEffect, useState } from "react";
import "@pathofdev/react-tag-input/build/index.css";
import './tags.css';
import ReactTagInput from "@pathofdev/react-tag-input";

const pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
};

const checkEmail = (value: string): boolean => (
  typeof value === 'string' && value.length <= 320 && !!value.match(pattern.email)
);

export interface FieldData
{
  name: string | number,
  errors: string[]
}

export interface EmailTagInputProps
{
  name: string,
  value?: string[],
  onChange: (newTags: string[]) => void,
  onError: (errors: FieldData[]) => void,
}

export const EmailTagInput = ({ name, value = [], onChange, onError }: EmailTagInputProps): JSX.Element => {
  const [tags, setTags] = useState<string[]>([]);

  useEffect(() => {
    setTags(value);
  }, []);

  return (
    <ReactTagInput 
      tags={tags} 
      placeholder="Type email, then press enter"
      editable={true}
      readOnly={false}
      removeOnBackspace={true}
      onChange={(newTags) => {
        setTags(newTags);
        onChange(newTags)
        //form.setFieldsValue({ employeeEmails: newTags });
      }}
      validator={value => {
        const valid = checkEmail(value);
        if (!valid) {
          //form.setFields([{ name: 'employeeEmails', errors: ['Please enter a valid email'] }]);
          onError([{ name, errors: ['Please enter a valid email'] }]);
        }
        return valid;
      }}
    />
  );
}
